import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';

import {ShToastModule} from '@stylehaven/components';

import {OperatorFactory} from './services/operator-factory.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, TranslateModule, ShToastModule],
    exports: [],
    providers: [OperatorFactory]
})
export class OperatorFactoryModule {}
export { ToastUpdateOptions } from './entity/toast-update-options.entity';
export * from './services/operator-factory.service';
